const getScriptInHead = (head, url) => {
  const scripts = head.getElementsByTagName('script');
  for (let i = 0; i < scripts.length; i += 1) {
    if (scripts[i].src === url) return scripts[i];
  }
  return false;
};

export const loadEstimatorScript = (fileVersion, onLoadFunction, isMobile) => {
  function paymentEstimatorExists() {
    return window && window.THD && window.THD.PaymentEstimator;
  }

  function createScript(fileUrl, head) {
    const script = document.createElement('script');
    script.setAttribute('src', fileUrl);
    script.onload = () => {
      onLoadFunction(isMobile);
    };
    head.appendChild(script);
  }

  function updateExistingScript(head, fileUrl) {
    const script = getScriptInHead(head, fileUrl);
    if (paymentEstimatorExists()) {
      onLoadFunction(isMobile);
    } else {
      let previousOnLoad = script.onload;
      script.onload = () => {
        previousOnLoad();
        onLoadFunction(isMobile);
      };
    }
  }

  if (paymentEstimatorExists()) {
    onLoadFunction(isMobile);
  } else {
    const location = window ? window.location.host.toLowerCase() : '';
    const isLlcEnvironment = location.includes('hd-qa71.homedepotdev')
      || location.includes('hd-qa74.homedepotdev')
      || location.includes('localhost');
    const fileUrl = isLlcEnvironment
      ? `https://assets-qa.homedepot-static.com/paymentestimator/${fileVersion}/payment-estimator.js`
      : `https://assets.homedepot-static.com/paymentestimator/${fileVersion}/payment-estimator.js`;
    const head = document.querySelector('head');
    if (getScriptInHead(head, fileUrl)) {
      updateExistingScript(head, fileUrl);
    } else {
      createScript(fileUrl, head);
    }
  }
};

const introOfferDetails = (estimator, price, isMobile) => {
  const { defaultApplynowLinks } = estimator || {};
  const links = defaultApplynowLinks ? defaultApplynowLinks('pip') : null;
  if (!links) {
    return {};
  }
  return { applyNowUrl: isMobile ? links.mobileUrl : links.desktopUrl };
};

export const getPaymentEstimatorDetails = (price, isMobile, isAppliance) => {
  const estimator = window && window.THD ? (window.THD || {}).PaymentEstimator : null;
  if (!estimator) {
    return false;
  }
  if (price < 299) {
    return introOfferDetails(estimator, price, isMobile);
  }
  const { currentPromotionDates, estimatedPayments, paymentEstimatorApplynowLinks, toolTipText } = estimator;
  const { monthlyPayment, promotionTerm } = estimatedPayments ? estimatedPayments(price, isAppliance) : {};
  const { promoStartDate, promoEndDate } = currentPromotionDates ? currentPromotionDates() : {};
  const { mobileUrl, desktopUrl } = paymentEstimatorApplynowLinks
    ? paymentEstimatorApplynowLinks('pip', isAppliance) : {};
  const tooltipText = toolTipText ? toolTipText() : null;
  let details = {};

  if (window.THD && window.THD.PaymentEstimator) {
    details = {
      displayPrice: monthlyPayment,
      promotionTerm,
      applyNowUrl: isMobile ? mobileUrl : desktopUrl,
      activeStartDate: promoStartDate,
      activeEndDate: promoEndDate,
      tooltipText
    };
  }
  return details;
};
